import { combineReducers } from 'redux';
import { UNIVERSAL_SEARCH_COMPONENT_STATE_KEY, UNIVERSAL_SEARCH_LOCATION_KEY } from '../constants/StateConstants';
import componentStateReducer from './componentStateReducer';
import coordinateReducer from './coordinateReducer';

export const reducers = {
    [UNIVERSAL_SEARCH_COMPONENT_STATE_KEY]: componentStateReducer,
    [UNIVERSAL_SEARCH_LOCATION_KEY]: coordinateReducer,
};

export default combineReducers(reducers);
